module.exports = __webpack_public_path__ + "static/media/custom.255b0f18.svg";